import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { map } from 'rxjs/operators';
// import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { ConfigService } from 'src/app/shared/config';
@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(
    private config: ConfigService,
    private afs: AngularFirestore, private notifierService: NotificationService, private authService: AuthService) {

  }

  addCompany(object) {
    object.updatedOn = moment().unix();
    object.createdOn = moment().unix();
    this.afs.collection('company')
      .add(object).then(data => {
        this.notifierService.showNotification('success', "Successfully added");
      })
      .catch(err => {
        this.notifierService.showNotification('error', "Some issue in adding");
      })
  }


  /**
   * Stockout notifications for the active company within [start, end].
   * Defaults to today when no range is given. Results are not ordered server side
   * (that would need an extra composite index) - the caller sorts in memory.
   */
  getNotifications$(start?: Date, end?: Date) {
    const from = start ? start : moment().startOf('day').toDate();
    const to = end ? end : moment().endOf('day').toDate();
    return this.afs
      .collection('notification', ref => ref
        .where('transactionObj.companyId', '==', this.config.getCompanyId())
        .where('createdAt', '>=', from)
        .where('createdAt', '<=', to)
      ).snapshotChanges().pipe(map(doc => {
        return doc.map(obj => {
          const data = obj.payload.doc.data() as any;
          const tx = data['transactionObj'] || {};
          const createdDate: Date = data['createdAt'].toDate();
          // The alert is raised per channel, but the order carries the app's
          // snapshot of the product's stock across the whole system
          // (extraInfo.quantity, before this purchase). If that minus what was
          // bought is still above the threshold, the product was not out.
          let extra: any = {};
          try {
            extra = typeof tx['extraInfo'] === 'string' ? JSON.parse(tx['extraInfo']) : (tx['extraInfo'] || {});
          } catch (e) { }
          const before = extra && extra.quantity !== undefined && extra.quantity !== null && !isNaN(Number(extra.quantity))
            ? Number(extra.quantity) : null;
          // Newer alerts store the system-wide stock after the purchase themselves.
          const left = data['productQuantity'] !== undefined ? Number(data['productQuantity'])
            : before === null ? null : before - Number(tx['quantity'] || 1);
          const stockStatus = left === null ? 'unknown' : (left <= Number(data['threshold'] || 0) ? 'real' : 'stock-left');
          return {
            ...data as object,
            createdAtDate: createdDate,
            createdAtUnix: moment(createdDate).unix(),
            createdAt: createdDate.toLocaleString(),
            productName: tx['productName'] ? tx['productName'] : "Not Available",
            productId: tx['productId'] ? tx['productId'] : "",
            system: tx['systemName'] ? tx['systemName'] : "Not Available",
            systemId: tx['systemId'] ? tx['systemId'] : "",
            machineCode: tx['machineCode'] ? tx['machineCode'] : "",
            stockBefore: before,
            stockLeft: left,
            stockStatus,
          }
        })
      }))
  }

  refundPayment() {
    this.notifierService.showNotification('info', "Refund is currently disabled. Contact support");

  }

  getOrderDetail(orderId) {
    return this.afs.collection('orderDetail', ref => ref.where('orderId', '==', orderId)).snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {
        return {
          ...obj.payload.doc.data()  as object
        }
      });
    }))
  }

}
